import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=1b3bb276&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=1b3bb276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3bb276",
  null
  
)

export default component.exports